import { useEffect } from 'react';

import { getIsBarGraphIntroductionSkipped } from '../../../../../db/polls';

export interface UseIntroduction {
  goToNextStep: () => void;
}

const useIntroduction = ({ goToNextStep }: UseIntroduction) => {
  useEffect(() => {
    const skipIntroduction: boolean = getIsBarGraphIntroductionSkipped();
    if (!skipIntroduction) return;

    goToNextStep();
  }, []);
};

export default useIntroduction;
